import { z } from 'zod';
import { CoreS3FileUsageSchema } from '../inputTypeSchemas/CoreS3FileUsageSchema'
import { CoreS3FileStatusSchema } from '../inputTypeSchemas/CoreS3FileStatusSchema'

/////////////////////////////////////////
// CORE S 3 FILE SCHEMA
/////////////////////////////////////////

export const CoreS3FileSchema = z.object({
  usage: CoreS3FileUsageSchema,
  status: CoreS3FileStatusSchema,
  id: z.number().int(),
  cityId: z.number().int(),
  uuid: z.string(),
  s3Key: z.string(),
  bucket: z.string(),
  s3StorageClass: z.string().nullable(),
  sizeInBytes: z.bigint().nullable(),
  originalFileName: z.string(),
  fileExtension: z.string(),
  fileUpdatedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  deleteRequestedAt: z.coerce.date().nullable(),
  deletedAt: z.coerce.date().nullable(),
})

export type CoreS3File = z.infer<typeof CoreS3FileSchema>

export default CoreS3FileSchema;
